import { DictContext } from "@/layout/context/DictContext";
import { Select, SelectProps } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

type SelectPackageTypePros<T> = Omit<SelectProps<T>, "options">

function SelectPackageType<T>(props: SelectPackageTypePros<T>) {
  const { t } = useTranslation();
  const { packageTypes } = useContext(DictContext);

  return (
    <Select
      {...props}
      options={
        packageTypes.map(pack => ({ key: pack.key, label: pack.desc, value: pack.key }))
      }
      placeholder={t('warehouse.packageType')}
    />
  )
};

export default SelectPackageType;
